import React from 'react';
// import ReactTooltip from 'react-tooltip';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';

// import { Link } from "react-router-dom";

import {  apiUrl } from "Api/Api";
// user_access_level, , myHeaders_Auth_With_Cache_Control
import axios from "axios";

import UserContext from 'store/UserContext';

//import { local_routes } from 'utils/Routes';

//import UserContext from 'store/UserContext';

//import { assembleNickname } from "utils/Helper.js";

//import './style.css';


function PublishButton (props) {
  const [entity_info, setEntityInfo] = React.useState({});
  
  let user_context = React.useContext(UserContext);
  
  function onStatusChange (new_status_code) {
    setEntityInfo({
      ...entity_info,
      status_code: new_status_code
    });
    let patch_obj = {
      status_code: new_status_code
    };
    axios.patch(`${apiUrl}${entity_info.entity_type}/${entity_info.entity_uuid}`, patch_obj);
  }
  
  //console.log("PublishButton",entity_info);

  // on mount
  React.useEffect(() => {
    console.log("PublishButton useEffect",props.entity_info);
    setEntityInfo(props.entity_info);
  }, [props.entity_info]);

  if (!entity_info.status_code) {
    return (<React.Fragment></React.Fragment>)
  }
  
  return (
    <ToggleButtonGroup
      //style={{ height: "80%" }}
      size="sm"
      type="radio"
      name="status_code"
      //name="venue_type"
      value={entity_info.status_code}
      onChange={onStatusChange}
    >
      <ToggleButton
        variant={user_context.theme === 'dark' ? "outline-light" : "outline-dark"}
        //style={{ whiteSpace: "nowrap" }}
        
        //name="venue_type"
        value={4}
        disabled={!entity_info.publishable}
      >
        {entity_info.status_code === 1 ? 'Unpublish' : 'Unpublished'}
      </ToggleButton>
      <ToggleButton
        variant={user_context.theme === 'dark' ? "outline-light" : "outline-dark"}
        //variant="outline-dark"
        //style={{ whiteSpace: "nowrap" }}
        
        //name="venue_type"
        value={1}
        disabled={!entity_info.publishable}
        
      >
        {entity_info.status_code === 1 ? 'Published' : 'Publish'}
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

export default PublishButton;